// ─── Index Route ───
// Redirects to the default workspace/space.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Redirect to the app root. The app route will handle
    // redirecting to the first workspace/space if available.
    throw redirect({ to: '/app' });
  },
});
